import {Approvisionnement} from '@/models';

export default [
	{
		path: '/approvisionnements',
		name: 'approvisionnements',
		meta: {
			title: 'Liste des approvisionnements',
			granted: [ 'API_GET_APPROVISIONNEMENT' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Approvisionnement.vue')
	},
	{
		path: '/approvisionnement/show/:id',
		name: 'approvisionnement-show',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Approvisionnement/Show.vue'),
				class: Approvisionnement
			}),
			editRoute: { name: 'approvisionnement-edit' },
		},
		meta: {
			title: 'Détail d\'un approvisionnement',
			granted: [ 'API_GET_APPROVISIONNEMENT' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
	{
		path: '/approvisionnement/edit/:id',
		name: 'approvisionnement-edit',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Approvisionnement/Edit.vue'),
				class: Approvisionnement
			}),
		},
		meta: {
			title: 'Edition d\'un approvisionnement',
			granted: [ 'API_PUT_APPROVISIONNEMENT' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
];
